module.exports = __webpack_public_path__ + "static/media/iPhoneX.7b459ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iPhoneX.png
// module id = 57
// module chunks = 0